import SeparateWallModel2d from '@/editor/entities/2d/separateWallModel';
import SeparateWallEntity from '../separateWallEntity';

export default class SeparateSelectedEntity extends SeparateWallEntity {
  constructor(params: { id?: string }) {
    super(params);

    this._model2d = new SeparateWallModel2d({ id: params.id, intersectable: false });
  }
}
